module.exports = __webpack_public_path__ + "img/weather-hyperlocal.1409743a.svg";